@if (loading()) {
  <div
    class="h-full w-full flex justify-center items-center text-primary dark:text-primary-darkmode"
  >
    <ui-loading-spinner size="24" />
  </div>
} @else if (error()) {
  <app-error-component
    class="block h-full w-full"
    [enableRetry]="true"
    (clickRetry)="clickReload.emit()"
  />
} @else {
  <ui-chart
    [options]="graphOptions()"
    [setOptionOpts]="{ notMerge: false, replaceMerge: ['series'] }"
    theme="stromify-dark"
    class="hidden dark:block h-full w-full"
  />
  <ui-chart
    [options]="graphOptions()"
    [setOptionOpts]="{ notMerge: false, replaceMerge: ['series'] }"
    theme="stromify-light"
    class="dark:hidden h-full w-full"
  />
}
